export const formatNumberWithCommas = (num: string | number) => {
  const numStr = typeof num === "number" ? num.toString() : num;

  if (!numStr) {
    return "0";
  }

  if (numStr.length < 4) {
    return numStr;
  }
  return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
